/**
 * @file 知识库面板搜索框 Portal（替代 NR 内置输入，避免客户端二次过滤）
 */
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Icon, Input } from 'tea-component';

/** Portal 搜索框 Props */
export interface IKbPanelSearchInputPortalProps {
  /** 面板 overlay 根节点 */
  overlayEl: HTMLElement | null;
  /** 搜索关键词 */
  value: string;
  /** 关键词变更 */
  onChange: (keyword: string) => void;
  /** 搜索框 placeholder */
  placeholder: string;
  /** overlay 重挂载 token */
  mountToken: number;
}

/**
 * 将搜索框挂到 NR 搜索区，NR 原生 input 隐藏且不参与过滤
 */
const KbPanelSearchInputPortal: React.FC<IKbPanelSearchInputPortalProps> = ({
  overlayEl,
  value,
  onChange,
  placeholder,
  mountToken,
}) => {
  const [mountNode, setMountNode] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!overlayEl) {
      setMountNode(null);
      return undefined;
    }
    const wrap = overlayEl.querySelector<HTMLElement>(
      '.dbc-region-select-search-input-wrap-inner',
    );
    if (!wrap) {
      setMountNode(null);
      return undefined;
    }
    let slot = wrap.querySelector<HTMLElement>('.dba-kb-panel-search-slot');
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'dba-kb-panel-search-slot';
      wrap.appendChild(slot);
    }
    setMountNode(slot);
    return () => {
      slot?.remove();
    };
  }, [overlayEl, mountToken]);

  if (!mountNode) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className="dba-kb-panel-search">
      <Input
        value={value}
        placeholder={placeholder}
        className="dbc-region-select-search-input dba-kb-panel-search-input"
        type="text"
        onChange={(val) => {
          onChange(val || '');
        }}
      />
      {(value || '').length > 0 && (
        <span
          className="dba-kb-panel-search-dismiss"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onChange('');
          }}
        >
          <Icon type="dismiss" />
        </span>
      )}
    </div>,
    mountNode,
  );
};

export default KbPanelSearchInputPortal;
